import { render, staticRenderFns } from "./SwitchInput.vue?vue&type=template&id=d9cd7e3c&"
import script from "./SwitchInput.vue?vue&type=script&lang=js&"
export * from "./SwitchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports